import { jsPDF } from "jspdf";
import { DIRECTION_OPTIONS } from "utils/constanst";

const loadImageAsBase64 = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(file);
  });
};

const loadImageDimensions = (src) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve({ img, width: img.width, height: img.height });
    img.onerror = reject;
    img.src = src;
  });
};

const createPdfFromImage = async (imageData, width, height) => {
  const pdf = new jsPDF({
    orientation: width > height ? "landscape" : "portrait",
    unit: "px",
    format: [width, height],
    hotfixes: ["px_scaling"],
  });
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();
  pdf.addImage(imageData, "JPEG", 0, 0, pdfWidth, pdfHeight);
  return pdf;
};

const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

const retrieveDirectionValue = (sensor) => {
  const countableCamera = sensor?.data?.trafficVolumeCountableCamera;
  let directionValue = null;
  if (countableCamera == 1) {
    directionValue = sensor?.data?.camera1Direction;
  }
  if (countableCamera == 2) {
    directionValue = sensor?.data?.camera2Direction;
  }
  const directionOption = DIRECTION_OPTIONS.find(option => option.value === directionValue);
  if (!directionOption) return null;
  if (['INBOUND', 'OUTBOUND'].includes(directionOption?.value)) return directionOption.label;
  return `${directionOption.label}方向`;
};

export {
  loadImageAsBase64,
  loadImageDimensions,
  createPdfFromImage,
  downloadBlob,
  retrieveDirectionValue,
};
